import { makeStyles } from "@material-ui/core";

export const useActivityItemDetailsFormStyles = makeStyles((theme) => ({
  section: {
    border: "1px solid #e3e7ee",
    borderRadius: 8,
    padding: "16px 20px",
    marginBottom: 16,
    background: "#fcfcfd",
    display: "flex",
    flexDirection: "column",
  },
  sectionTitle: {
    fontSize: "0.95rem",
    fontWeight: 600,
    marginBottom: 18,
  },
  sectionSubtitle: {
    fontSize: "0.85rem",
    color: theme.palette.text.secondary,
    marginBottom: 12,
  },
  fullRow: {
    width: "100%",
  },
  dropdownStyle: {
    minWidth: 260,
    width: "100%",
  },
  paramTypes: {
    marginLeft: "8px",
    maxWidth: 250,
  },
  alert: {
    alignItems: "center",
    "& .MuiAlert-icon": {
      fontSize: 25,
    },
  },
  addMaterialButton: {
    marginTop: 8,
  },
}));
